'use client';
import { useState, useEffect, useRef } from 'react';

const services = [
  { icon: 'fas fa-stethoscope', title: 'Médecine Générale', text: 'Spécialité clé du centre, elle permettra de répondre à 80% des demandes de consultation. Médecin référent pour les entreprises partenaires et le Groupe Cofina.' },
  { icon: 'fas fa-user-md', title: 'Médecine Spécialisée', text: 'Le centre propose des spécialités permettant de traiter des pathologies spécifiques en fonction des besoins exprimés par les patients.' },
  { icon: 'fas fa-home', title: 'Médecine de Proximité', text: 'Grâce à ce service, nous pouvons réaliser des diagnostics directement au domicile des patients, sur demande.' },
  { icon: 'fas fa-laptop-medical', title: 'Télémédecine', text: 'Cette innovation permet d\'effectuer des diagnostics à distance grâce à des outils spécialisés et à l\'expertise de professionnels qualifiés.' },
  { icon: 'fas fa-flask', title: 'Analyses Biomédicales', text: 'Grâce au partenariat avec le Laboratoire Montagnier, nous réalisons des analyses biomédicales de haute précision.' },
  { icon: 'fas fa-ambulance', title: 'Évacuation Sanitaire', text: 'Partenariat avec les services et autorités locales pour accompagner et prendre en charge nos patients vers des centres hospitaliers spécialisés.' },
  { icon: 'fas fa-heartbeat', title: 'Suivi Préventif', text: 'Suivi complet avant et après les pathologies, incluant des services de diététique, kinésithérapie, optique et bien d\'autres encore.' },
  { icon: 'fas fa-shield-alt', title: 'Programmes de Prévention', text: 'Vaccinations, examens de santé, bilans annuels et programmes de prévention pour les employés des entreprises partenaires.' },
];

export default function ServicesSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 4;
  const maxIndex = services.length - itemsPerView;
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex(prev => (prev >= maxIndex ? 0 : prev + 1));
    }, 3000);
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [maxIndex]);

  const goTo = (idx: number) => {
    setCurrentIndex(idx);
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  return (
    <section id="services-3" className="wide-100 bg-lightgrey">
      <div className="max-w-7xl mx-auto px-4">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h3 className="text-3xl md:text-4xl font-black mb-4" style={{ color: '#1d3c5e', fontFamily: 'Lato, sans-serif' }}>
            Nos Services Médicaux & Paramédicaux
          </h3>
          <p className="text-gray-500 max-w-xl mx-auto">
            COSA innove dans la gestion des services de santé en Côte d'Ivoire en apportant un savoir-faire unique autour de services médicaux, paramédicaux et de bien-être.
          </p>
        </div>

        {/* CAROUSEL */}
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentIndex * (100 / itemsPerView)}%)` }}
          >
            {services.map((svc, i) => (
              <div
                key={i}
                className="flex-shrink-0 px-3"
                style={{ width: `${100 / itemsPerView}%`, minWidth: `${100 / itemsPerView}%` }}
              >
                <div className="sbox-3">
                  <div className="sbox-3-icon">
                    <i className={svc.icon}></i>
                  </div>
                  <h5 className="font-bold text-base mb-3" style={{ color: '#1d3c5e' }}>{svc.title}</h5>
                  <p className="text-sm text-gray-500 leading-relaxed">{svc.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* DOTS */}
        <div className="flex justify-center gap-2 mt-8">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className="w-3 h-3 rounded-full transition-all border-none cursor-pointer"
              style={{ backgroundColor: i === currentIndex ? '#0e5932' : '#ddd' }}
              aria-label={`Aller à la diapositive ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
